module.exports = __webpack_public_path__ + "favicon.ico?d0d550b8936f9c0d7a82f3dc2c724980";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon.ico
// module id = 69
// module chunks = 0